<template>
	<header class="header">
		<div class="header-brand" @click="toHomePage">/ BUILDlite / Domain</div>
		<nav class="header-nav">
			<div class="header-nav-name">{{ userName }}</div>
			<div class="header-nav-item" @click="toHomePage" v-if="!isStaff">Home</div>
			<div class="header-nav-item" @click="toReportPage">Report</div>
			<div class="header-nav-item" @click="toJobListPage">Jobs</div>
			<div class="header-nav-item" @click="signOut">Sign Out</div>
		</nav>
	</header>
</template>

<script>
import { isStaff } from '@/utils/Help.js'

export default {
	name: 'NavBar',
	computed: {
		nameInitial() {
			const givenName = JSON.parse(sessionStorage.user).givenName
			return givenName && givenName[0]
		},
		isStaff() {
			return isStaff()
		},
		userName() {
			const name = JSON.parse(sessionStorage.user).name
			return ` ${name}`
		}
	},
	methods: {
		toHomePage() {
			if (this.isStaff) {
				this.$router.push({
					name: 'job-list'
				})
			} else {
				this.$router.push({
					name: 'home'
				})
			}
		},
		toJobListPage() {
			this.$router.push({
				name: 'job-list'
			})
		},
		toReportPage() {
			this.$router.push({
				name: 'report'
			})
		},
		signOut() {
			sessionStorage.removeItem('token')
			sessionStorage.removeItem('refreshToken')
			sessionStorage.removeItem('user')
			this.$router.push({
				name: 'login'
			})
		}
	}
}
</script>

<style lang="scss" scoped>
@import '../styles/components/navBar.scss';
</style>
